// extracted by mini-css-extract-plugin
var _1 = "CompanyLink-moduleCompanyLink__jbr98";
export { _1 as "CompanyLink" }
